import { Modal, Theme } from '@carbon/react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { useImagePreview } from '../context/image-preview';

import './ImagePreviewModal.scss';

const ImagePreviewModal = ({ id }) => {
  const { t } = useTranslation();
  const { isOpen, previewImage, modalRef, closeImagePreview } = useImagePreview();

  return createPortal(
    <Theme id={id} theme='g100'>
      <Modal
        className='image-preview-modal'
        ref={modalRef}
        open={isOpen}
        onRequestClose={closeImagePreview}
        modalHeading={t('Image Preview')}
        autoFocus={false}
        passiveModal
      >
        {previewImage && (
          <img
            className='image-preview-modal__img'
            src={previewImage.src}
            alt={previewImage.alt}
          />
        )}
      </Modal>
    </Theme>,
    document.body,
  );
};

ImagePreviewModal.displayName = 'ImagePreviewModal';
ImagePreviewModal.propTypes = {
  id: PropTypes.string,
};

export default ImagePreviewModal;
